import {v4} from "uuid";
import {Table} from "antd";
import {useUser} from "../../Context/UserContext";

export default function ResultOutputTable({render, data, globalVariables, Component}) {
    const {user} = useUser()
    return (
        <Table
            style={{marginTop: 16}}
            id={v4()}
            size={'small'}
            rowKey={'id'}
            className={'check-result'}
            dataSource={data}
            pagination={false}
            columns={[
                {dataIndex: 'error_id', title: 'Message Code', key: 'error_id', width: '30mm', },
                // {dataIndex: 'description', title: 'Description', key: 'description', render: (text, row) => render(text, row, user.settings, globalVariables)},
                {dataIndex: 'description', title: 'Description', key: 'description', render: (text, row) => (<Component text={text} row={row} settings={user.settings} globalVariables={globalVariables} />) },
            ]}
        />
    )
}